import React from 'react';
import { HeroSection } from './HeroSection';
import { MirrorSection } from './MirrorSection';
import { ProblemSection } from './ProblemSection';
import { SolutionSection } from './SolutionSection';
import { TimelineSection } from './TimelineSection';
import { OfferSection } from './OfferSection';
import { FooterSection } from './FooterSection';
export function SalesPage() {
  return <main className="min-h-screen bg-cream font-body text-text-dark selection:bg-gold-light selection:text-text-dark" data-id="element-81">
      <HeroSection data-id="element-82" />
      <MirrorSection data-id="element-83" />
      <ProblemSection data-id="element-84" />
      <SolutionSection data-id="element-85" />
      <TimelineSection data-id="element-86" />
      <OfferSection data-id="element-87" />
      <FooterSection data-id="element-88" />
    </main>;
}